import SystemModalClosingCrossIcon from "../../icons/SystemModalClosingCrossIcon";

export default function GlossaryDetailedScreenHeader({ term,
                                                     handleClose }) {
    // Used in GlossaryDetailedScreen to display Term word
    // in header

    // BUILD
    return (
        <div className="w-full flex justify-start items-start space-x-[12px] px-[16px] py-[12px] border-b border-greyLight5 bg-gradient-to-br from-backgroundLight3 to-backgroundLight1">
            <div className={" grow flex flex-col justify-start items-start"}>
                <span className={"font-medium text-[18px] text-greyLight11"}>
                    {term.word}
                </span>
            </div>
            <SystemModalClosingCrossIcon onIconPress={handleClose} />
        </div>
    );
}